import { ActivityRegisterInfoBackend, AntiSpamSwitchType, SwitchGroupEnum } from 'common-package';
/* eslint-disable react-func/max-lines-per-function */
import { AxiosInstance } from 'axios';
import Qs from 'query-string';
import { FilterOptions } from 'common-package/src/types';
import { ActivityInfo, UserActivity, GarbageDetectionForm, SpaceActivityItem } from '../constants';

export const getActivityServices = ({ GateWayInstance }: { GateWayInstance: AxiosInstance }) => ({
  // 网关接口
  getActivityCenterInfoById(aid: string) {
    return GateWayInstance.get<ActivityInfo>(`/activity_center/activity/${aid}`);
  },
  getActivities(data: any) {
    return GateWayInstance.get<{ items: UserActivity[] }>(`/users/activities`, {
      params: { ...data },
    });
  },
  subscribeActivity({ aid, is_subscribe }: { aid: string; is_subscribe: boolean }) {
    return GateWayInstance.put(`/activities/subscribe/${aid}`, { is_subscribe });
  },
  getActivityRegisterInfo(aid: string) {
    return GateWayInstance.get<ActivityRegisterInfoBackend>(`/register/${aid}`);
  },
  getGarbageDetection(formData: GarbageDetectionForm, aid?: string, switchType?: AntiSpamSwitchType) {
    return GateWayInstance.post(`/antispam`, {
      ...formData,
    })
      .then(data => data.data)
      .catch(err => err?.response?.data);
  },

  // 企业控制台-创建活动
  createSpaceActivity(space_id: string) {
    return GateWayInstance.post<{ aid: string }>(`/spaces/activities/${space_id}`);
  },

  // 企业控制台-活动卡片查询接口
  getSpaceActivities(space_id: string, params: { name?: string; status?: string[] } & FilterOptions) {
    return GateWayInstance.get<{
      items: SpaceActivityItem[];
      total: number;
    }>(`/spaces/${space_id}/activities/list`, {
      params,
      paramsSerializer: function (params) {
        return Qs.stringify(params, { arrayFormat: 'comma' });
      },
    });
  },

  // 企业控制台-删除活动
  deleteSpaceActivity(aid: string) {
    return GateWayInstance.put(`/activities/cancel/${aid}`);
  },
  // 批量查询某个活动的功能开关配置
  getBulkFeatureSwitch(aid?: string, switchGroups?: number[]) {
    return GateWayInstance.get(`/activities/${aid}/bulk/switch?switch_group=${switchGroups?.join(',')}`);
  },
  // 查询某个活动的功能开关配置
  getActivityStatus(aid?: string) {
    return GateWayInstance.get(`/activities/${aid}/switch?switch_group=${SwitchGroupEnum.Func}`);
  },
  // 查询某个活动下反垃圾的功能开关配置
  getActivityAntiSpamStatus(aid?: string) {
    return GateWayInstance.get(`/activities/${aid}/switch?switch_group=${SwitchGroupEnum.AntiSpam}`);
  },
  getBrandInfo(aid: string) {
    return GateWayInstance.get(
      `/activities/${aid}/switch?${Qs.stringify({
        switch_group: SwitchGroupEnum.Oem,
      })}`,
    );
  },
  // 空间活动复制
  copySpaceActivity(activity_id: string) {
    return GateWayInstance.post(`/activities/${activity_id}/copy`);
  },
});
